import { render, staticRenderFns } from "./falling-heart.vue?vue&type=template&id=7aec55b3"
import script from "./falling-heart.vue?vue&type=script&lang=js"
export * from "./falling-heart.vue?vue&type=script&lang=js"
import style0 from "./falling-heart.vue?vue&type=style&index=0&id=7aec55b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports